

// Api call and response related utils

// ---- Get json object nested value
export const get_nested = (p, o, default_value = null, suffix = '') => {
    let res = p.reduce((xs, x) => (xs && xs[x] ? xs[x] : default_value), o)
    if (suffix && res !== default_value) res += suffix
    return res
}